const activeContractsMixin = {
  computed: {
    contracts() {
      const stateContracts = this.$store.state.contracts?.subscriptions;
      const getterContracts = this.$store.getters['contracts/get'];

      if (Array.isArray(stateContracts) && stateContracts.length > 0) {
        return stateContracts;
      }
      if (Array.isArray(getterContracts)) {
        return getterContracts;
      }
      return [];
    },
    hasActiveContracts() {
      return this.contracts.some(({ status }) => status === 'ACTIVE' || status === 'SUSPENDED' || status === 'CANCELLED');
    },
    coulddeleteaccount() {
      return !this.hasActiveContracts;
    },
  },
  methods: {
    async ensureContractsLoaded() {
      if (Array.isArray(this.contracts) && this.contracts.length > 0) {
        return;
      }
      try {
        await this.$store.dispatch('orders/setOrders');
      } catch (err) {
        console.error('Failed to load contracts:', err);
      }
    },
  },
};

export default activeContractsMixin;
